document.addEventListener('DOMContentLoaded', () => {
  const announcement = document.querySelector(
    '.cart-drawer-announcement'
  );

  if (!announcement) return;

  const message = announcement.querySelector(
    '.cart-announcement-message'
  );

  if (!message) return;

  const messages = [
    'Buy Combo at ₹2999',
    'EXTRA 10% OFF On Prepaid  | USE CODE : PREPAID',
    'Free Gift on orders above ₹2,999',
    'PREMIUM JEWELLERY | SHOP NOW'
  ];

  let index = 0;

  setInterval(() => {
    message.classList.add('is-changing');

    setTimeout(() => {
      index = (index + 1) % messages.length;
      message.textContent = messages[index];

      message.classList.remove('is-changing');
    }, 300);

  }, 3000);
});